import type { $Fetch } from 'nitropack';
import type { IApi } from '~/types/api';
import { defineNuxtPlugin } from '#app';
import { useCustomFetch } from '~/uses/useCustomFetch';

import DefaultFetch from '~/repositories/DefaultFetch';
import Forms from '~/repositories/Forms';
import Catalog from '~/modules/catalog/repositories/Catalog';
import Auth from '~/modules/auth/repositories/Auth';
import Categories from '~/modules/categories/repositories/Categories';
import Cart from '~/modules/cart/repositories/Cart';
import Visitors from '~/modules/visitors/repositories/Visitors';
import Favorites from '~/modules/favorites/repositories/Favorites';
import Menu from '~/modules/menu/repositories/Menu';
import Cabinet from '~/modules/cabinet/repositories/Cabinet';
import Posts from '~/modules/posts/repositories/Posts';
import User from '~/modules/user/repositories/User';
import Orders from '~/modules/checkout/repositories/Orders';
import UserOrders from '~/modules/user/repositories/Orders';
import InfoPages from '~/modules/infoPages/repositories/InfoPages';
import DaData from '~/repositories/DaData';
import Constructor from '~/modules/constructor/repositories/Constructor';

export default defineNuxtPlugin((nuxtApp) => {
  const { APP_URL, NODE_ENV, API_BASE_URL, VERSION_MODE, DADATA_TOKEN, DADATA_SECRET } = useRuntimeConfig().public;
  const apiUrl = NODE_ENV === 'production' && VERSION_MODE !== 'stage' ? API_BASE_URL : APP_URL;
  const fetch = useCustomFetch(apiUrl, APP_URL, useRequestEvent());

  const modules: IApi = {
    defaultFetch: new DefaultFetch({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    forms: new Forms({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    catalog: new Catalog({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    auth: new Auth({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    users: new User({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    userOrders: new UserOrders({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    orders: new Orders({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    categories: new Categories({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    cart: new Cart({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    visitors: new Visitors({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    favorites: new Favorites({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    menu: new Menu({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    cabinet: new Cabinet({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    posts: new Posts({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    infoPages: new InfoPages({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    constructor: new Constructor({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }),
    daData: new DaData({
      baseURL: '/api/',
      fetch: fetch as $Fetch,
    }, { secret: DADATA_SECRET, token: DADATA_TOKEN }),
  };

  nuxtApp.provide('api', modules);
});
